import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './modules/auth/services/auth.guard';
import { CarbonCalculateComponent } from './pages/carbon-calculate/carbon-calculate.component';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./modules/errors/errors.module').then((m) => m.ErrorsModule),
  },

  {
    path: 'carbon-event',
    loadChildren: () =>
      import('./pages/carbon-calculate/carbon-calculate.module').then(
        (m) => m.CarbonCalculateModule,
      ),
  },
  {
    path: 'carbon-personnel-calculate',
    loadChildren: () =>
      import('./pages/carbon-personel-calculate/carbon-personel-calculate.module').then(
        (m) => m.CarbonPersonelCalculateModule,
      ),
  },
  {
    path: 'sme-green-finance',
    loadChildren: () =>
      import('./pages/sme-green-finance/sme-green-finance.module').then(
        (m) => m.SmeGreenFinanceModule,
      ),
  },
  {
    path: 'sme-green-result',
    redirectTo: 'sme-green-finance/public-result',
    pathMatch: 'prefix',
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./_metronic/layout/layout.module').then((m) => m.LayoutModule),
  },
  {
    path: 'emissiondata-history',
    loadChildren: () =>
      import('./pages/emissiondata-history/emissiondata-history.module').then(
        (m) => m.EmissiondataHistoryModule,
      ),
  },
  {
    path: 'emissiondata-prevyears',
    loadChildren: () =>
      import('./pages/emissiondata-prevyears/emissiondata-prevyears.module').then(
        (m) => m.EmissiondataPrevyearsModule,
      ),
  },
  {
    path: 'base-year-comparison',
    loadChildren: () =>
      import('./pages/base-year-comparison/base-year-comparison.module').then(
        (m) => m.BaseYearComparisonModule,
      ),
  },
  {
    path: 'suppliers',
    loadChildren: () =>
      import('./pages/suppliers/suppliers.module').then(
        (m) => m.SuppliersModule,
      ),
  },
  {
    path: 'reporting',
    loadChildren: () =>
      import('./pages/reporting/reporting.module').then(
        (m) => m.ReportingModule,
      ),
  },

  // { path: '**', redirectTo: 'carbon-event' }, // Diğer tüm yolları yönlendirme
  { path: '**', redirectTo: 'error/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
